export const Field = {
  name: "position-select",
  component: "NewPositionSelect",
  layout: "field-map",
  mode: "visible",
  showOn: [true],
  actionGroups: [
    {
      actions: [
        // Show Floating Panel
        { action: "nextState", value: "main-buttons", type: "primary" },
      ],
      conditions: [],
    },
  ],
};
